import {
  Component,
  OnInit,
  OnChanges,
  Output,
  Input,
  EventEmitter,
  SimpleChanges,
  ChangeDetectionStrategy,
  HostListener,
  AfterViewInit
} from '@angular/core';
import OlMap from 'ol/Map';
import { environment } from '../../../../environments/environment';
import { DisplayService } from '../../../services/display.service';
import { QueryOptionService } from '../services/query-option.service';
import { EditFeatureService } from '../services/edit-feature.service';
import { LayerService } from 'src/app/services/layer.service';
import { AppText, FeatureDrawInfo, featureQueryViewPackage, Languages, mapLayer } from 'src/app/interfaces/common';
import { GeoJSONFeature } from 'ol/format/GeoJSON';

@Component({
  selector: 'app-show-feature-data',
  templateUrl: './show-feature-data.component.html',
  styleUrls: ["./show-feature-data.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowFeatureDataComponent implements OnInit, OnChanges, AfterViewInit {
  @Output() closeShowFeatureDataEE = new EventEmitter();

  @Input() featureDataFeature : featureQueryViewPackage | null = null;
  @Input() selText : AppText = {};
  @Input() lang: Languages = Languages.Icelandic;
  @Input() mapObject: OlMap = new OlMap();
  @Input() applicationSettings: any;

  propertiesData: any[] = [];

  container: HTMLElement | null = null;
  matTableElems: any;
  tabsElems: any;
  latLongCoordinatesElem: HTMLElement | null = null;
  ISN2016coordinatesElem: HTMLElement | null = null;
  megaContainer: HTMLElement | null = null;

  isMobile: boolean = false;

  lmiGulur: string = "#ffe600";
  gudnaBlar:string = "#4e8ecc";
  gudnaLettari:string = "#c8def6";
  gudnaBlarFaded:string = 'rgba(78,142,204,0.8)';

  switchCanvas: HTMLCanvasElement | null = null;
  ctx: any;

  mobileOrNot: number = 0;
  mobileOrNotTooltip: string = '';

  mobileIcon: Path2D = new Path2D();
  desktopIcon: Path2D = new Path2D;

  //Only want dragging on rows to be possible when show-feature is in "mobile" mode.
  draggingDisabledOnRows: boolean = true;
  /*
    Is necessary for edit-feature-data. Keeps a list of all features currently in the table.
    edit-feature-data needs the raw non-mutated feature, but not the feature after it has been
    processed by show-feature-dataþcomponent and query-option.service.
  */
  allFeaturesCache: GeoJSONFeature[] = [];

  /*
    Why use hostListener instead of f.ex window.addEventListener? 
    Because once you use addEventListener, it is listening forever untill you manually unlisten to it.
    Even if component is destroyed the listener will still be active. But using hostListener then Angular will
    unlisten to the event when the component gets destroyed.
  */
  @HostListener("window:resize")
  onResize() {
    //Set into mobile view if width of screen is to small
    if (window.innerWidth > 1100) {
      this.isMobile = false;
      if (this.getTableDisplayMode() === "auto") {
        this.megaContainer?.classList.remove("mobile")
      }
      this.draggingDisabledOnRows = true
    } else {
      this.isMobile = true;
      if (this.getTableDisplayMode() === "auto") {
        this.megaContainer?.classList.add("mobile")
      }
      this.draggingDisabledOnRows = false;
    } 
  }

  constructor(
    public displayService:DisplayService,  
    private QueryOptionService: QueryOptionService,
    private layerService: LayerService,
    private editFeatureService: EditFeatureService) { }

  ngOnInit(): void {
    
    this.mobileIcon = new Path2D("M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7.01 13.47l-2.55-2.55-1.27 1.27L7 16l7.19-7.19-1.27-1.27z");
    this.desktopIcon = new Path2D("M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z");
    this.mobileOrNotTooltip = this.selText.changeTableToMobile;
  }

  ngAfterViewInit(): void {
    this.container = document.getElementById("showFeatureDataContainer");
    this.matTableElems = document.getElementsByClassName("showFeatureTable");
    this.tabsElems = document.getElementsByClassName("tabs");
    this.megaContainer = document.getElementById("megaContainer");

    //this.switchCanvas = <HTMLCanvasElement>document.getElementById("switchDisplayMode");
    //this.ctx = this.switchCanvas.getContext("2d");
    //this.switchDisplayMode(0);

    if (window.innerWidth > 1100) {
      this.isMobile = false 
    } else {
      this.isMobile = true
      this.megaContainer?.classList.add("mobile")
    } 

  }

  /*
  ngAfterViewChecked() {
    
  }
  */

  ngOnChanges(changes: SimpleChanges): void {
    //console.log(changes)
    if( !environment.production ) {
      //console.log("INPUTS TO SHOW-FEATURE HAS CHANGED............")
      //console.log(changes)
      //console.log("featureDataFeature: ");
      //console.log(R.clone(this.featureDataFeature));

      //console.log("Map Object: ");
      //console.log(this.mapObject);

      //console.log("Seltext: ");
      //console.log(this.selText);

      //console.log("MapLayers: ");
      //console.log(this.mapLayers);

      //console.log(this.applicationSettings)
    }

    if (this.featureDataFeature?.geoJSONFeature?.features && this.featureDataFeature.geoJSONFeature.features.length > 0) {
      //Clone because we need the original non-mutated feature to sedn to edit-feature-data.component
      this.allFeaturesCache = [...this.allFeaturesCache, ...structuredClone(this.featureDataFeature?.geoJSONFeature.features)]
    }
    
    if (this.isMobile == true) {
      this.mobileOrNotTooltip = this.selText.changeTableToDesktop;
    } else {
      this.mobileOrNotTooltip = this.selText.changeTableToMobile;
    }
    
    //Only build featurest if input for them has changed
    if (Object.keys(changes).includes("featureDataFeature")) {   
      //console.log("Running buildFeatures()")  
      if (this.featureDataFeature) this.buildFeatures(this.featureDataFeature)
    }
    
    document.getElementById("mapid")?.focus({preventScroll: true});
    
  }

  /*
  ngOnDestroy(): void {
    //console.log("show-feature-componet DESTROYED")
  }
    */

  switchDisplayMode(mode: number): void {
    this.mobileOrNot += mode;
    
    this.ctx.clearRect(0, 0, this.switchCanvas?.width, this.switchCanvas?.height);
    this.ctx.fillStyle = "white";

    if (this.getTableDisplayMode() === "auto") {
      //Visual representation of button
      this.ctx.beginPath();
      this.ctx.setTransform(1, 0, 0, 1, 0, 0);
      this.ctx.translate(3, 0);
      this.ctx.fill(this.mobileIcon);
      this.ctx.closePath();
      
      //The actual change to 'auto' mode of table
      if (this.isMobile != true) this.megaContainer?.classList.remove("mobile");
      
      this.mobileOrNotTooltip = this.selText.changeTableToMobile
      this.draggingDisabledOnRows = true;
    }

    if (this.getTableDisplayMode() === "mobile") {
      //Visual representation of button
      this.ctx.beginPath();
      this.ctx.setTransform(1, 0, 0, 1, 0, 0);
      this.ctx.translate(4.5, 0);
      this.ctx.fill(this.desktopIcon);
      this.ctx.closePath();
      //The actual change to 'mobile (rowColumns)' mode of table
      this.megaContainer?.classList.add("mobile");

      this.mobileOrNotTooltip = this.selText.changeTableToDesktop;
      this.draggingDisabledOnRows = false;
    }
  }

  getTableDisplayMode(): string {
    return this.mobileOrNot % 2 === 0 ? "auto" : "mobile"
  }

  tableVisibility(id: string): void {
    //console.log("TAB VIZ")
    //Tabs styling
    for (const tab of this.tabsElems) {
      tab.style.removeProperty("background-color");
      tab.style.removeProperty("color");
      if (tab.innerText === id) {
        tab.style.backgroundColor = this.gudnaBlar;
        tab.style.color = "white";
      }
    }

    //Show/hide tables
    if (this.matTableElems.length > 0) {
      for (const tableElem of this.matTableElems) {
        tableElem.style.display = "none";
        if (tableElem.id === id) {
          tableElem.style.display = "block";
        }
      }
    }
  }

  buildFeatures(fqvp: featureQueryViewPackage): void {
    //Loops through each layer where query was active
    if (fqvp?.geoJSONFeature?.features?.length === 0) return

    //let oneTable = { tabHeader: "", layerID: undefined as number | undefined, headers: [], values: [], columnKeys: [] };
    const oneTable: {
      tabHeader: string;
      layerID: number | undefined;
      headers: any[];
      values: any[];
      columnKeys: any[];
    } = {
      tabHeader: "",
      layerID: undefined,
      headers: [],
      values: [],
      columnKeys: [],
    };
    /*
      11. Feb:
      Dont have to find the layer with layerService.findLayer() anymore since it gets passed down
      from map.component along with everything else! Now we can have 2 or more layers with same layer name
      without the displaying of features failing.
    */
    const layer: mapLayer = fqvp?.metadataLayer
    //if (this.displayService.getLayerQueryView(layer.id) !== "default") {
      //console.log("Found layer that does not have default display: " + layer.id + " Had displaymode: " + this.displayService.getLayerQueryView(layer.id))
      //return
    //}

    //let emptyColumnsAcc: string[] = []

    //Loops through each feature in that layer
    for (let v = 0; v < (fqvp?.geoJSONFeature?.features?.length ?? 0); v++) {
    
      const feat = fqvp?.geoJSONFeature?.features[v];
      if (!feat) continue
    
      const tabHeader = layer.title_lang[this.lang];
      const layerID = layer.id;

      oneTable.tabHeader = tabHeader;
      oneTable.layerID = layerID;

      let props: any = {};
      props = feat.properties;
        
      let headers: any[] = [];
      let columnKeys: any[] = [];
      //let values = {};
      let values: { [key: string]: any } = {};

      if (layer.query_option) {
        if ("skip_columns" in layer.query_option) {
          //didApplySkipColumns = true;
          const skipColumns = layer.query_option.skip_columns
          props = this.QueryOptionService.removeSkipColumns(skipColumns, props);
        }

        //Always remove empty columns, Only case where we keep the columns is if keepEmptyColumns is defined and is true
        if (!layer?.query_option?.keepEmptyColumns) {
          const columnsWithNoValue: string[] = this.QueryOptionService.detectEmptyColumns(props)
          //emptyColumnsAcc = [...emptyColumnsAcc, ...columnsWithNoValue]
          props = this.QueryOptionService.removeEmptyColumns(columnsWithNoValue, props)
        }

        if ("values_columns" in layer.query_option) {
          const valueColumns = layer.query_option.values_columns
          props = this.QueryOptionService.applyValueColumns(valueColumns, props);
        }
        
        const renameColumns = layer.query_option.rename_columns || {}

        //console.log("Applying rename columns")
        /*
          Update 16. April, Always apply renameColumns, even if it does not exist.
          Why? renameColumns also formats the data, which is necessary for later on in this buildFeatures.
          Söguleg kort Dana failed because only skip_columns was defined(in db) and applied.
        */
        props = this.QueryOptionService.renameColumns(renameColumns, props, this.lang);
    
        if ("measurement_units" in layer.query_option) {
          const measurementUnits = layer.query_option.measurement_units;
          props = this.QueryOptionService.addMeasurementUnits(measurementUnits, props);
        }

        //Formatting data to what mat-table likes to consume
        props.forEach( (row: any) => {
          headers.push(row.header)
          columnKeys.push(row.key)
          values[row.key] = row.value
        });

      } else {
        //This is when there is no query_option on layer -> object keys as headers and so on
        columnKeys = Object.keys(props)
        headers = Object.keys(props)
        values = props
      }
      
      oneTable.columnKeys = [...new Set([...oneTable.columnKeys, ...columnKeys])];
      oneTable.headers = [...new Set([...oneTable.headers, ...headers])];;
      //adding geometry back to values(not shown in table). Need it to display feature on hover or click
      values["geometry"] = feat.geometry;
      //adding the feature id back to values(not shown in table). Need it for plucking out right feature to send to edit-feature-data.component
      values["featID"] = feat.id;
      //adding the CRS this feature is in(not shown in table). Need it for displaying/drawing the feature - Possibly do conversion if feat CRS is different than the view CRS.
      values["featureCRS"] = fqvp?.geoJSONFeature?.crs?.properties?.name
      oneTable.values.push(values);
    }

    //const numFeatures: number = fqvp?.geoJSONFeature?.features.length
    //const columnsThatSomeFeaturesNeedAdding: string[] = [...new Set(emptyColumnsAcc)].filter((uniqueEmptyColumn: string) => {
      //const numEmptyColumns: number = emptyColumnsAcc.filter((emptyColumn: string) => emptyColumn === uniqueEmptyColumn).length
      //return numEmptyColumns !== numFeatures
    //})

    //Add test data for content-decider...
    //oneTable.columnKeys.push("TextURL")
    //oneTable.headers.push("TexURL")
    //oneTable.values.forEach(v => {
      //v["TextURL"] = "Svo tók hann af https://ftp.lmi.is/stm/michaela/ramma/pictures/S%C3%B3lheimar.png, skari, maðurinn, minn "
      //v["TextURL"] = "https://husaskraning.minjastofnun.is/Husakonnun_170.pdf, https://husaskraning.minjastofnun.is/Husakonnun_170.pdf, https://husaskraning.minjastofnun.is/Husakonnun_170.pdf"
    //})

    this.propertiesData.push(oneTable)
  }
  /* 
    Sets an edit button as the last column in the table. When clicked it goes to edit-feature-data.component.
    Given the condition that the layer is defined to be an editable layer: 
    (applicationSettings?.option?.tables?.[applicationName]?.layers) exists and contains same layer name as current feature is from
  addMaybeEditFeatureOption(layer: mapLayer, oneTable: any): any {
    const applicationName: string = this.applicationSettings?.application
    
    const layersWithEditOption: string[] = this.applicationSettings?.option?.tables?.[applicationName]?.layers

    //return non-mutated table if layersWithEditOption is not even defined for this app
    if (!layersWithEditOption) return oneTable
    //return non-mutated table if layersWithEditOption does not contain the layer name fomr which this table came from
    if (!layersWithEditOption.includes(layer.name)) return oneTable

    oneTable.columnKeys.push("editButtonColumn")
    oneTable.headers.push("")
    return oneTable
  }
  */
  
  goToEditFeature(featureProperties: any): void {
    this.editFeatureService.initializeLength();
    this.displayService.setEditFeatureActive(true)
    
    const featureToEdit: any = this.allFeaturesCache.find((feature: any) => feature.id === featureProperties.featID)

    const layerFeatCameFrom: mapLayer | undefined = this.layerService.findLayerByFeatureId(featureToEdit.id);
    
    if(layerFeatCameFrom) {
      this.editFeatureService.setCurrentLayer(layerFeatCameFrom);
    }
    
    if (!featureToEdit) console.warn("Feature not found! Cant set into editFeatureService")

    this.editFeatureService.setNewGeoFeature(featureToEdit);
  }

  displayFeature(feature: any, layerID: number, cameFrom: "click" | "search"): void {
    //Clearing possible old drawn features from old click on another feature in the list
    this.displayService.clearFeaturesByCameFrom("click")
    const displayFeature: FeatureDrawInfo = {geometry: feature.geometry, featureCRS: feature.featureCRS}
    this.displayService.displayFeature(displayFeature, layerID, cameFrom);
  }

  closeShowFeatureData(): void {
    //this.container.style.visibility = "hidden";
    this.closeShowFeatureDataEE.emit("");
    document.getElementById("mapid")?.focus({preventScroll: true});
  }
  /*
    Disable tooltip if content is dataURL or array of something.
    Might be to slow/too many executions to call method directly in template?
  */
  disableTooltip(content: any): boolean {
    //console.log("Running isDataURL...")
    //console.log(content)
    if (Array.isArray(content)) return true
    
    content = String(content)
    const mediaType: string = content?.split(";", 1)[0]
    if (mediaType.includes("image")) {
      return true
    }
    return false
  }
}